import { useState } from "react";
import styled from "@emotion/styled";

import { pluralise } from "../../lib/utils";
import { Flex, Text } from "../../styles/utility-components";
import Button from "../ui/button/Button";
import { BidAssigneeBulkUpdateButton } from "./BidAssigneeBulkUpdateButton";
import { BidStageBulkUpdateButton } from "./BidStageBulkUpdateButton";
import DeleteBidsModal from "./DeleteBidsModal";

export default function BidsActionBar({
  selectedBidIds,
  onClearSelection,
}: {
  selectedBidIds: string[];
  onClearSelection: () => void;
}) {
  const [isDiscardModalOpen, setIsDiscardModalOpen] = useState(false);

  return (
    <>
      <Container aria-label="Bids bulk action bar">
        <Flex gap={16} alignItems="center">
          <Text color="white">{pluralise(selectedBidIds.length, "bid")} selected:</Text>
          <ActionButtonWrapper>
            <BidStageBulkUpdateButton selectedBidIds={selectedBidIds} />
          </ActionButtonWrapper>
          <ActionButtonWrapper>
            <BidAssigneeBulkUpdateButton selectedBidIds={selectedBidIds} />
          </ActionButtonWrapper>
          <ActionButtonWrapper>
            <Button icon="trash01" onClick={() => setIsDiscardModalOpen(true)}>
              Delete
            </Button>
          </ActionButtonWrapper>
        </Flex>
        <Flex gap={8} alignItems="center">
          <Button icon="xClose" onClick={onClearSelection}>
            Deselect all
          </Button>
        </Flex>
      </Container>
      <DeleteBidsModal
        isOpen={isDiscardModalOpen}
        onOpenChange={(open: boolean) => setIsDiscardModalOpen(open)}
        onSuccess={onClearSelection}
        selectedBidIds={selectedBidIds}
      />
    </>
  );
}

const Container = styled(Flex)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  height: 48,
  padding: 8,
  backgroundColor: theme.colors.sysPrimaryDefault,
  borderRadius: 4,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
}));

const ActionButtonWrapper = styled.div(({ theme }) => ({
  border: `1px solid ${theme.colors.sysTextWhite}`,
  borderRadius: 4,
  position: "relative",
}));
